import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { isEqual } from 'lodash';
import { GlobalAppState } from '@model/state';
import { CMSComponentTypes } from '@components/cms';
import { ComponentTypes } from '@model/contentful';

/* ***************** *
 *       TYPES       *
 * ***************** */

export type ComponentsDataState = {
  main: Array<ComponentData> | [];
  sidebar: Array<ComponentData> | [];
};

export interface ComponentData {
  componentType: ComponentTypes;
  data: any;
}

export type ComponentDataPayload = Array<ComponentData>;

export interface SetComponentsDataPayload {
  componentsData: ComponentDataPayload;
  cmsComponentType: CMSComponentTypes;
}

/* ***************** *
 *   ACTION TYPES    *
 * ***************** */

export enum ComponentDataActionTypes {
  SLICE_NAME = '@COMPONENTS_DATA',
  FETCH_COMPONENTS_DATA = '@COMPONENTS_DATA/fetchComponentsData',
  SET_COMPONENTS_DATA = '@COMPONENTS_DATA/setComponentsData'
}

/* ***************** *
 *     ACTIONS       *
 * ***************** */

export const INITIAL_COMPONENTS_DATA_STATE: ComponentsDataState = {
  main: [],
  sidebar: []
};

export const componentsDataSlice = createSlice({
  name: ComponentDataActionTypes.SLICE_NAME,
  initialState: INITIAL_COMPONENTS_DATA_STATE,
  reducers: {
    setComponentsData: (state, action: PayloadAction<SetComponentsDataPayload>) => {
      const { cmsComponentType, componentsData } = action.payload;
      state[cmsComponentType] = componentsData;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action: any) => {
      const hydratePayload = action.payload as GlobalAppState;
      if (
        !isEqual(state, hydratePayload.componentsData) &&
        (hydratePayload.componentsData.main.length || hydratePayload.componentsData.sidebar.length)
      ) {
        return hydratePayload.componentsData || state;
      }
      return state;
    });
  }
});

export const { setComponentsData } = componentsDataSlice.actions;

export const componentsDataReducer = componentsDataSlice.reducer;
